import React, { FC, ReactElement } from 'react'
import { system as s } from '@moonpig/launchpad-system'
import { Box, Flex, Heading } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { spacingPx } from '@moonpig/launchpad-theme'
import { ResultsCountHeader } from '../ResultsCountHeader'

const StyledGalleryHeader = styled(Flex)`
  align-items: center;
  flex-direction: row;
  ${({ theme }) =>
    s({
      gap: spacingPx(3)({ theme }),
    })}
`

type Props = {
  title: string
  count: number
  rudeToggle?: ReactElement
}

export const Header: FC<Props> = ({ title, count, rudeToggle = null }) => (
  <StyledGalleryHeader>
    <Box width="100%">
      <Heading
        display="inline"
        level="h1"
        typography={{
          xs: 'typeMobileDisplay03',
          md: 'typeDesktopDisplay03',
        }}
      >
        {title}
      </Heading>
      &nbsp;
      <ResultsCountHeader count={count} />
    </Box>

    <Box display="flex" flexShrink={0} marginLeft="auto">
      {rudeToggle}
    </Box>
  </StyledGalleryHeader>
)
